import React, { createRef, forwardRef, useImperativeHandle, useRef, useState } from "react";
import { nextTick } from "../../utils/obj-utils";
import Swiper from "swiper";
import { BodyText, Icon } from "../../elements";
import SiteModal from "../../elements/site-modal";
import { MODAL_ANI_TYPES } from "../../utils/modal-animations";
import "./style.scss";
import { S_LANG, webStorage } from "../../utils/webStorage";

const ImageCarouselModal = forwardRef((props, ref) => {
  const swiper = createRef();
  const swiperNode = useRef(null);
  const leftNode = useRef(null);
  const rightNode = useRef(null);
  const [items, setItems] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [show, setShow] = useState(false);
  const [isAR, setIsAR] = useState(false);
  const onCloseClick = e => {
    setShow(false);
    if (swiper.current) {
      swiper.current.destroy(true, true);
    }
  };
  useImperativeHandle(ref, () => ({
    open: (slides, index = 0) => {
      const lang = webStorage.get(S_LANG);
      const _isAR = false;
      setItems(slides);
      setActiveIndex(index);
      setShow(true);
      setIsAR(_isAR);
      nextTick(() => {
        if (swiper.current) {
          swiper.current.update();
        } else {
          swiper.current = new Swiper(swiperNode.current, {
            slidesPerView: 1,
            initialSlide: index,
            spaceBetween: 16,
            navigation: {
              prevEl: ".s-image-carousel-modal__left, .s-image-carousel-modal__guide-left",
              nextEl: ".s-image-carousel-modal__right, .s-image-carousel-modal__guide-right"
            },
            pagination: {
              el: ".s-image-carousel-modal__pagination"
            },
            on: {
              slideChange() {
                if (this) {
                  setActiveIndex(this.realIndex);
                }
              }
            }
          });
        }
      }).catch();
    }
  }));
  return (
    <SiteModal className="s-image-carousel-modal" open={show} animation={MODAL_ANI_TYPES.bottomFadeIn} onMaskClick={onCloseClick}>
      <div className="s-image-carousel-modal__header">
        <div className="s-image-carousel-modal__guide">
          <Icon name="ArrowBack" className="s-image-carousel-modal__guide-left" ref={leftNode} />
          <div className="s-image-carousel-modal__guide-page">
            <span className="s-image-carousel-modal__guide-current">{isAR ? items.length - activeIndex : activeIndex + 1}</span>
            <span>/</span>
            <span>{items.length}</span>
          </div>
          <Icon name="ArrowForward" className="s-image-carousel-modal__guide-right" ref={rightNode} />
        </div>
      </div>
      <div className="swiper-container" ref={swiperNode}>
        <div className="swiper-wrapper">
          {items.map((x, index) => (
            <ImageCarouselModalSlide {...x} key={index} />
          ))}
        </div>
        <i className="s-image-carousel-modal__close" onClick={onCloseClick}>
          ×
        </i>
      </div>
      <div className="s-image-carousel-modal__footer">
        <BodyText html={items && items[activeIndex]?.title} className="s-image-carousel-modal__title" />
        <div className="s-image-carousel-modal__nav">
          <Icon name="ArrowBack" className="s-image-carousel-modal__left" />
          <div className="s-image-carousel-modal__pagination" />
          <div className="s-image-carousel-modal__guide-page">
            <span className="s-image-carousel-modal__guide-current">{isAR ? items.length - activeIndex : activeIndex + 1}</span>
            <span>/</span>
            <span>{items.length}</span>
          </div>
          <Icon name="ArrowForward" className="s-image-carousel-modal__right" />
        </div>
      </div>
    </SiteModal>
  );
});
const ImageCarouselModalSlide = ({ image }) => (
  <div className="s-image-carousel-modal__slide swiper-slide">
    <div className="s-image-carousel-modal__slide-img" style={{ backgroundImage: `url(${image.src})` }} />
  </div>
);
ImageCarouselModal.displayName = "ImageCarouselModal";
export default ImageCarouselModal;
